import React, { useState } from 'react';
import './Login.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002';

interface LoginProps {
  onLogin: (token: string) => void;
  onSwitchToPublisher?: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin, onSwitchToPublisher }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!username.trim() || !password) {
        throw new Error('Username and password are required');
      }

      const response = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username.trim(),
          password
        })
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data.success || !data.token) {
        throw new Error(data.message || 'Invalid username or password');
      }

      onLogin(data.token);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img
            src="/site-logo.jpeg"
            alt="AdBizz Media"
            style={{
              width: '200px',
              height: 'auto',
              marginBottom: '20px'
            }}
          />
        </div>
        <h2 className="login-title">Please sign in</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        {onSwitchToPublisher && (
          <div className="publisher-login-section">
            <div className="publisher-login-divider">
              <span>OR</span>
            </div>
            <button
              type="button"
              className="publisher-login-button"
              onClick={onSwitchToPublisher}
            >
              Login as Publisher
            </button>
            <p className="publisher-login-hint">
              Are you a publisher? Click above to access your dashboard
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
